export enum ActivitySource {
  EMPTY = 'EMPTY',
  NO_DATA = 'NO_DATA',
  DRIVER = 'DRIVER',
  TACHOGRAPH = 'TACHOGRAPH',
  ANALOG = 'ANALOG',
  USER = 'USER',
  DRIVER_1 = 'DRIVER_1',
  DRIVER_2 = 'DRIVER_2',
  REST = 'REST',
  FILE = 'FILE',
}
